import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

export default function IntroStep({ onStart }) {
  return (
    <div className="w-full max-w-4xl mx-auto">
      {/* Header with Phone */}
      <div className="flex flex-col items-center mb-12">
        <div className="mb-4">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/525d05658fdf988acaa34e738d3f286826191483600217441074af5254e1324b9947d16ec384fcc03e2360d22f6a7d9b/images/aW1hZ2UvcG5n/312034cd79c028aad1e85c1e994b94aa.png" 
            alt="Pinoy General Insurance Services" 
            className="w-64 md:w-80 h-auto object-contain hover:scale-105 transition-transform duration-300"
          />
        </div>
        <a 
          href="tel:5624021737" 
          className="flex items-center gap-2 text-blue-800 font-semibold hover:text-blue-700 transition-colors"
        >
          <SafeIcon name="Phone" className="w-4 h-4" />
          (562) 402-1737
        </a>
      </div>

      {/* Main Hero Content */}
      <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100">
        <div className="p-8 md:p-16 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-6">
              Are you really protected if <span className="text-[#DC143C]">disaster strikes?</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto mb-10 leading-relaxed">
              Most business owners think their basic policy covers everything. It doesn't. Find out your risk level in 60 seconds.
            </p>

            <button
              onClick={onStart}
              className="group relative inline-flex items-center justify-center px-10 py-5 font-bold text-white transition-all duration-200 bg-emerald-500 font-pj rounded-2xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 hover:bg-emerald-600 shadow-lg hover:shadow-emerald-200"
            >
              Start Risk Assessment
              <SafeIcon name="ArrowRight" className="ml-3 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
            
            <p className="mt-6 text-sm text-gray-400 flex items-center justify-center gap-2">
              <SafeIcon name="Clock" className="w-4 h-4" />
              Takes less than 1 minute • Free professional review
            </p>
          </motion.div>
        </div>

        {/* Value Props Section */}
        <div className="bg-gray-50 border-t border-gray-100 p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="flex flex-col items-center text-center">
              <div className="w-14 h-14 bg-white rounded-2xl shadow-sm flex items-center justify-center mb-4 border border-gray-100">
                <SafeIcon name="Target" className="w-7 h-7 text-blue-800" />
              </div>
              <h3 className="font-bold text-blue-900 mb-2">Identify Gaps</h3>
              <p className="text-sm text-gray-600">See exactly where your business is financially vulnerable.</p>
            </div>

            <div className="flex flex-col items-center text-center">
              <div className="w-14 h-14 bg-white rounded-2xl shadow-sm flex items-center justify-center mb-4 border border-gray-100">
                <SafeIcon name="TrendingDown" className="w-7 h-7 text-emerald-500" />
              </div>
              <h3 className="font-bold text-blue-900 mb-2">Stop Overpaying</h3>
              <p className="text-sm text-gray-600">Find out if you're paying too much for basic coverage.</p>
            </div>

            <div className="flex flex-col items-center text-center">
              <div className="w-14 h-14 bg-white rounded-2xl shadow-sm flex items-center justify-center mb-4 border border-gray-100">
                <SafeIcon name="UserCheck" className="w-7 h-7 text-blue-800" />
              </div>
              <h3 className="font-bold text-blue-900 mb-2">Get Licensed Advice</h3>
              <p className="text-sm text-gray-600">Learn in plain English what your policy actually covers.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Trust Footer */}
      <div className="mt-12 flex flex-wrap justify-center items-center gap-8 opacity-50 grayscale hover:grayscale-0 transition-all duration-500">
        <p className="text-sm font-semibold text-gray-500 uppercase tracking-widest w-full text-center mb-4">Trusted by California Small Businesses</p>
        <div className="flex items-center gap-2 text-xl font-bold text-gray-600">
          <SafeIcon name="Shield" className="w-6 h-6" />
          <span>CA DOI LICENSED</span>
        </div>
        <div className="flex items-center gap-2 text-xl font-bold text-gray-600">
          <SafeIcon name="Lock" className="w-6 h-6" />
          <span>SECURE & PRIVATE</span>
        </div>
      </div>
    </div>
  );
}